var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.editorType,{ref:"editor",tag:"editor",class:_vm.classList,attrs:{"options":_vm.options,"propValue":_vm.propValue,"dataId":_vm.dataId,"rowIndex":_vm.rowIndex,"propReadonly":_vm.readonly},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }